import { type DrawerProps } from './Drawer';

export const DEFAULT_PROPS = {
  size: 'md',
} as const satisfies Omit<DrawerProps, 'children' | 'isOpen'>;

export const OVERLINE_STYLES = {
  color: 'feature.secondary',
  fontSize: 'sm',
  lineHeight: 'sm',
  fontWeight: 'heavy',
  textTransform: 'uppercase',
  mb: 0.5,
};
